import { render } from "./TemperatureResultRow.vue?vue&type=template&id=06596b3a&ts=true"
import script from "./TemperatureResultRow.vue?vue&type=script&lang=ts"
export * from "./TemperatureResultRow.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__